export const handleProductSelect = (props) => {
  const {
    item,
    saveSelectedProduct,
    resetData,
    history,
    changeView,
    isFromHomeGauge,
    savedevicelocation,
    setCurrentLocation,
  } = props;
  if (item) {
    const currentLiveLocation1 = JSON.parse(
      localStorage.getItem("current_live_location1")
    );
    const currentLiveLocation2 = JSON.parse(
      localStorage.getItem("current_live_location2")
    );
    if (
      currentLiveLocation1 &&
      currentLiveLocation2 &&
      currentLiveLocation1.zipcode !== currentLiveLocation2.zipcode
    ) {
      savedevicelocation(currentLiveLocation2);
      setCurrentLocation(currentLiveLocation2);
      localStorage.setItem(
        "current_live_location1",
        JSON.stringify(currentLiveLocation2)
      );
    } else {
      setCurrentLocation(currentLiveLocation1);
    }

    if (item.type === "B" && item.aliasName && item.aliasId) {
      const params = {
        ...item,
        productId: item.aliasId,
        productName: item.aliasName,
        type: "G",
      };
      saveSelectedProduct(params);
    } else {
      saveSelectedProduct(item);
    }
    resetData("productReset");

    const widgetEnabled = sessionStorage.getItem("widgetEnabled");
    const path =
      widgetEnabled === "Y"
        ? "SearchMedication?displayMode=widget"
        : "SearchMedication";

    changeView &&
      history.push(path, {
        isFromHomeGauge: isFromHomeGauge || false,
      });
  }
};

export const discountAndRetail = (props) => {
  const { getDiscountPrice, getRetailPrice, zipCode, id, appQuantity } = props;
  if (id !== "" && zipCode) {
    getDiscountPrice({
      productID: id,
      zipCode: zipCode,
      quantity: appQuantity,
    });
    getRetailPrice({
      productID: id,
      zipCode: zipCode,
      quantity: appQuantity,
    });
  }
};

export const handleDTCFavPharmacy = (authData) => {
  const { organization } = authData;
  const favouriteID = localStorage.getItem("pharmacyGroupId");
  const d1 = organization?.app?.appCode === "CVD";
  let d2 = organization?.restrictPharmacyGroupIdList;
  let d3 = false;
  if (
    d2?.length &&
    favouriteID &&
    favouriteID !== "" &&
    parseInt(favouriteID)
  ) {
    d3 = d2?.indexOf(parseInt(favouriteID)) !== -1;
  }
  return d1 && d3;
};

export const checkFavPharmacy = () => {
  const favouriteID = localStorage.getItem("pharmacyGroupId");
  let flag = false;
  if (favouriteID && favouriteID !== "" && parseInt(favouriteID)) {
    flag = parseInt(favouriteID);
  }
  return flag;
};

export const checkIfDTC = (authData) => {
  const { organization } = authData;
  const d1 = organization?.app?.appCode === "CVD";
  return d1;
};

export const handleBGColor = (value) => {
  const options = {
    WGN: "#323261",
  };
  return options[value] || "#003D4C";
};

export const handleTextColor = (value) => {
  const options = {
    WGN: "#FFF",
  };
  return options[value];
};

export const hideCVDFavoriteView = (authData) => {
  const d1 = authData?.organization?.app?.appCode !== "CVD";
  const d2 =
    authData?.organization?.organizationOptionJson?.restrictPharmacyGroupFlag?.toLowerCase() ===
    "y";
  const d3 = authData?.organization?.restrictPharmacyGroupIdList?.length <= 1;
  return d1 && d2 && d3;
};
